import { BCMBookingIdRemarkRuleFormData, BCMBookingIdRemarkRuleFormValidationData } from '../../../integrated-client/models';

export interface IRuleData {
  ruleFormData?: BCMBookingIdRemarkRuleFormData
  validation?: BCMBookingIdRemarkRuleFormValidationData
  readyToSaveRuleForm: boolean
}
export class RemarksRuleData implements IRuleData {

  ruleFormData?: BCMBookingIdRemarkRuleFormData
  validation?: BCMBookingIdRemarkRuleFormValidationData
  readyToSaveRuleForm: boolean

  constructor() {
    this.readyToSaveRuleForm = false;
  }
}